import axios from 'axios';
import { loginreq, req ,reqPost} from './axiosFun';
const BASE_URL="";
// 登录接口
export const login = (params) => { return loginreq("post", BASE_URL+"/api/user/loginByUsername", params) };
// 切换公司（老板/财务等多公司账号）
export const switchCompany = (companyId) => { return reqPost(BASE_URL+"/api/user/switchCompany", { companyId }) };
// 转换接口
export const format=(params)=>{return req("post", BASE_URL+"/api/format/relayFormat", params) }
// 获取用户菜单
export const menu = (params) => { return axios.get(BASE_URL+"/api/menu/getMenu", { headers: { Authorization: 'Bearer ' + localStorage.getItem('logintoken') } }).then(res => res.data) };
// 退出接口
export const loginout = () => { return axios.delete("/api/login", { headers: { Authorization: 'Bearer ' + localStorage.getItem('logintoken') } }).then(res => res.data) };

/**
 * 用户管理
 **/
// 用户管理-获取用户列表
export const userList = (params) => { return req("post", "/api/User/list", params) };
// 用户管理-保存（添加编辑）
export const userSave = (params) => { return req("post", "/api/User/save", params) };
// 用户管理-删除用户
export const userDelete = (params) => { return axios.delete("/api/User/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 用户管理-重置密码
export const userPwd = (params) => { return req("post", "/api/User/pwd", params) };
// 用户管理-修改状态
export const userLock = (params) => { return axios.get("/api/User/lock?userId=" + params.userId + "&lock=" + params.lock + "&token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限
export const UserDeptTree = (params) => { return axios.get("/api/UserDept/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限保存
export const UserDeptSave = (params) => { return req("post", "/api/UserDept/save", params) };
// 用户管理-获取部门设置
export const UserDeptdeptTree = (params) => { return axios.get("/api/UserDept/deptTree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-保存部门设置
export const UserChangeDept = (params) => { return req("post", "/api/User/change/dept", params) };
// 用户管理-用户下线
export const userExpireToken = (params) => { return req("get", "/api/User/expireToken/" + params, {}) };
// 用户管理-刷新缓存
export const userFlashCache = (params) => { return req("get", "/api/User/flashCache/" + params, {}) };

/**
 * 菜单管理
 **/
// 菜单管理-获取菜单Module/list
export const ModuleList = () => { return req("post", "/api/Module/list") };
// 菜单管理-根据菜单获取数据
export const ModuleGet = (params) => { return axios.get("/api/Module/get/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 菜单管理-获取父级菜单Module/nodes
export const ModuleNodes = (params) => { return req("post", "/api/Module/nodes", params) };
// 菜单管理-修改菜单
export const ModuleSave = (params) => { return req("post", "/api/Module/save", params) };
// 菜单管理-删除菜单
export const ModuleDelete = (params) => { return axios.delete("/api/Module/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 角色管理
 **/
// 角色管理-获取角色列表
export const roleList = (params) => { return req("post", "/api/Role/list", params) };
// 角色管理-保存（添加编辑）
export const roleSave = (params) => { return req("post", "/api/Role/save", params) };
// 角色管理-删除角色
export const roleDelete = (params) => { return axios.delete("/api/Role/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 角色管理-菜单权限（获取）
export const RoleRightTree = (params) => { return axios.get("/api/RoleRight/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 角色管理-菜单权限（保存）
export const RoleRightSave = (params) => { return req("post", "/api/RoleRight/save", params) };
/**
 * 基础管理
 **/
// 房型管理
export const roomAttribute = (params) => { return reqPost(BASE_URL+"/api/roomAttribute/getAllRoomAttribute", params) };
// 房型类型
export const roomAttributeType=() => { return req('get',BASE_URL+"/api/roomAttribute/getAllRoomAttributeType?token="+ localStorage.getItem('logintoken'), null) };
// 添加房型
export const roomAttributeSave = (params) => { return reqPost( BASE_URL+"/api/roomAttribute/saveAllRoomAttribute", params) };
//删除房型
export const deleteAttribute = (params) => { return reqPost(BASE_URL+"/api/roomAttribute/delete", { ids: params }) };

// 房间管理
export const roomList=(params)=>{ return reqPost( BASE_URL+"/api/roomManage/getRoom",params)};
// 添加房间
export const roomSave=(params) =>{return reqPost( BASE_URL+"/api/roomManage/saveRoom", params)}
// 房间入住
export const roomCheckIn=(params)=>{return reqPost( BASE_URL+"/api/roomFinance/roomCheckIn", params)}
// 房间续费
export const renew=(params)=>{return reqPost( BASE_URL+"/api/roomFinance/renew", params)}
// 房间退房
export const roomCheckOut=(params)=>{return reqPost( BASE_URL+"/api/roomFinance/roomCheckOut", params)}
// 换房
export const roomTransfer=(params)=>{return reqPost( BASE_URL+"/api/roomFinance/transfer", params)}
// 删除房间
export const roomDelete = (params) => { return reqPost(BASE_URL+"/api/roomManage/delete", { ids: params }) };
// 即将到期房间
export const expiringSoonRooms = (days) => { return axios.get(BASE_URL+"/api/roomManage/expiringSoon", { params: { days: days || 3 }, headers: { Authorization: 'Bearer ' + localStorage.getItem('logintoken') } }).then(res => res.data) };

/**
 * 系统环境变量
 **/
// 系统环境变量-获取系统环境变量列表
export const variableList = (params) => { return req("post", "/api/Variable/list", params) };
// 系统环境变量-保存（添加编辑）
export const variableSave = (params) => { return req("post", "/api/Variable/save", params) };
// 系统环境变量-删除系统环境变量
export const variableDelete = (params) => { return axios.delete("/api/Variable/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 权限管理
 **/
// 权限管理-获取权限列表
export const permissionList = (params) => { return req("post", "/api/Permission/list", params) };
// 权限管理-保存权限
export const ermissionSave = (params) => { return req("post", "/api/Permission/save", params) };
// 权限管理-删除权限
export const ermissionDelete = (params) => { return axios.delete("/api/Permission/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-获取权限
export const roleDropDown = () => { return axios.get("/api/Role/dropDown/all?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-配置权限
export const RolePermission = (params) => { return req("post", "/api/RolePermission/save", params) };

/**
 * 账号管理（仅财务）：角色、负责的公寓
 **/
export const userManageList = () => { return axios.get(BASE_URL+"/api/userManage/list", { headers: { Authorization: 'Bearer ' + localStorage.getItem('logintoken') } }).then(res => res.data) };
export const userManageCompanies = () => { return axios.get(BASE_URL+"/api/userManage/companies", { headers: { Authorization: 'Bearer ' + localStorage.getItem('logintoken') } }).then(res => res.data) };
export const userManageSave = (params) => { return reqPost(BASE_URL+"/api/userManage/save", params) };



// WEBPACK FOOTER //
// ./src/api/userMG.js